/** This file is auto generated by convertSvgToJsx.ts */

import React from 'react'
import type { IconSVGProps } from '../../components/icon/Icon'
const pin_code_medium = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeWidth={1.5}
      d="M15.5 6V2a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v20a1 1 0 0 0 1 1h11.5a1 1 0 0 0 1-1v-8m-6.924 6.01h.346m.779-9.9h.346m3.153 0h.347m3.153 0h.346m3.154 0h.346M9 20.01c0 .183-.16.243-.248.243-.092 0-.252-.06-.252-.243 0-.197.16-.257.252-.257.088 0 .248.06.248.257Zm1.125-9.9c0 .183-.16.243-.248.243-.092 0-.252-.06-.252-.243 0-.197.16-.257.252-.257.088 0 .248.06.248.257Zm3.5 0c0 .183-.16.243-.248.243-.092 0-.252-.06-.252-.243 0-.197.16-.257.252-.257.088 0 .248.06.248.257Zm3.5 0c0 .183-.16.243-.249.243-.091 0-.252-.06-.252-.243 0-.197.16-.257.252-.257.088 0 .248.06.248.257Zm3.499 0c0 .183-.16.243-.248.243-.092 0-.252-.06-.252-.243 0-.197.16-.257.252-.257.088 0 .248.06.248.257Z"
    />
  </svg>
)
export default pin_code_medium
